import { Link } from 'react-router-dom';
import './Header.scss';
import logo from '../../../assets/images/logo.svg';

import UserMenu from './UserMenu/UserMenu';
import classNames from 'classnames';
import type { FC } from 'react';

/**
 * @description Props for the Header component
 * @typedef {Object} HeaderProps
 * @property {boolean} showSidebar - Determines whether the sidebar is visible
 */
type HeaderProps = {
  showSidebar: boolean;
};

/**
 * @description Header component that displays the application's top navigation bar.
 * Includes logo and user menu with responsive styling based on sidebar visibility.
 *
 * @SADtrace SAD-003-1.1, SAD-003-2.1, SAD-003-3.1, SAD-003-4.1, SAD-003-5.1, SAD-003-6.1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @component
 * @param {HeaderProps} props - Component props
 * @param {boolean} props.showSidebar - Controls the styling of the logo wrapper based on sidebar visibility
 *
 * @returns {JSX.Element} Rendered Header component
 */
const Header: FC<HeaderProps> = ({ showSidebar }) => {
  const logoWrapperClasses = classNames({
    'top-navbar__logo-wrapper': true,
    'd-flex': true,
    'justify-content-center': true,
    'align-items-center': true,
    'no-sidebar': !showSidebar,
  });
  return (
    <header
      className="top-navbar d-flex justify-content-between"
      data-testid="header"
    >
      <div className={logoWrapperClasses}>
        <Link className="top-navbar__logo-link" to={'/'}>
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <div className="top-navbar__right d-flex pe-4">
        <UserMenu />
      </div>
    </header>
  );
};

export default Header;
